import React, { Component } from 'react'
import { connect } from "react-redux"
import { compose } from "recompose"

import { withStyles } from '@material-ui/core/styles';
import {
	Grid,
	Typography,
	Button
} from "@material-ui/core";

import DataTable from "../../reusable/DataTable"

import SurveyModel from "../../../model/Survey"
import noData from "../../../image/no-data.svg"
import columns from "./config/surveyTableConfig";
import Dispatch from "../../../constant/dispatch";

const styles = theme => ({
	root: {
		display: 'flex',
	},
	button: {
		margin: theme.spacing(1),
	},
});

class Survey extends Component {
	
	constructor(props) {
		super(props)
		
		// if(!this.props.isSurveyDataLoaded) {
			this.props.getSurveysData(this.props.currentEvent.id)
		// }
	}
	
	render() {
		const { classes, surveys } = this.props
		
		return <div className={classes.root}>
			{
				surveys.length === 0 ? <Grid
					container
					spacing={0}
					direction="column"
					alignItems="center"
					justify="center"
					style={{ minHeight: '80vh' }}>
					<Grid item xs={3} style={{ flexBasis: '0%' }}>
						<img src={noData} height={100} style={{marginBottom: "10px"}}/>
					</Grid>
					<Grid item xs={3} style={{ flexBasis: '0%' }}>
						<Typography color="textSecondary">
							You have no surveys yet.
						</Typography>
					</Grid>
					<Grid item xs={"auto"} style={{ flexBasis: '0%' }}>
						<Button
							color="primary"
							className={classes.button}
							onClick={() => this.props.openViewSurveyDialog(new SurveyModel())}>
							CREATE SURVEY
						</Button>
					</Grid>
				</Grid> : <DataTable
					title="Surveys"
					selectableRows="multiple"
					filter={false}
					data={surveys}
					columns={columns}
					createNew={() => this.props.openViewSurveyDialog(new SurveyModel())}
					onRowsDelete={survey => this.props.deleteSurvey(survey)} />
			}
		</div>
	}
}

const mapStateToProps = function(storage) {
	return {
		currentEvent: storage.eventManager.currentEvent,
		surveys: storage.survey.surveys,
		isSurveyDataLoaded: storage.survey.isSurveyDataLoaded
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		openViewSurveyDialog: survey => dispatch({
			type: Dispatch.OPEN_VIEW_SURVEY_DIALOG,
			payload: survey
		}),
		getSurveysData: eventId => dispatch({
			type: Dispatch.ON_GET_SURVEYS_REQUEST,
			payload: eventId
		}),
		deleteSurvey: survey => dispatch({
			type: Dispatch.ON_DELETE_SURVEY_BY_ID_REQUEST,
			payload: survey
		})
	}
}

export default compose(
	connect(
		mapStateToProps,
		mapDispatchToProps,
	),
	withStyles(styles)
)(Survey)
